import HttpService from "@/services/HttpService";

// Every method returns the API envelope's `data` (see the division access guide).
const DivisionAccessService = {
  async myDivisions() {
    const response = await HttpService.get("/my-divisions");
    return response.data?.data || [];
  },

  async allDivisions() {
    const response = await HttpService.get("/all-divisions");
    return response.data?.data || [];
  },

  async directory(params) {
    const response = await HttpService.get("/division-access/employees", {
      params,
    });
    return response.data?.data;
  },

  async updateAccess(employeeId, divisionIds) {
    const response = await HttpService.put(
      `/division-access/employees/${employeeId}`,
      { division_ids: divisionIds },
    );
    return response.data?.data || [];
  },
};

export default DivisionAccessService;
